/**
 * Author: Valeria Sinnati
 *  |\---/|
 *  | ,_, |   Costanti del tema, fuori da theme-toggle.tsx apposta: quello è un
 *   \_`_/   modulo 'use client' e in Next un server component che ne importa
 *            una stringa riceve un riferimento client, non la stringa.
 */

export type Tema = 'light' | 'dark'

export const CHIAVE_TEMA = 'tema'

/** Inline nell'<head>: applica il dark salvato prima che la pagina si dipinga */
export const SCRIPT_TEMA = `try{if(localStorage.getItem('${CHIAVE_TEMA}')==='dark')document.documentElement.dataset.theme='dark'}catch(e){}`
